import {
  CLAUSE_CHECK,
  CONTRACT_COMPLIANCE,
  CONTRACT_COMPLIANCE_HEADER_DESCP,
  CONTRACT_REVIEW,
  CONTRACT_REVIEW_PENDING_HEADER_DESCP,
  CONTRACTS_COMPLETE_REVIEW,
  CONTRACTS_COMPLETE_REVIEW_HEADER_DESCP,
  CONTRACTS_PENDING_CLAUSE_CHECK,
  CONTRACTS_PENDING_CLAUSE_CHECK_HEADER_DESCP,
  CONTRACTS_REVIEW_PENDING,
  DASHBOARD_FEATURES,
  GREEN,
  headerActionsForClauseCheck,
  headerActionsForContractReview,
  hideMetaDataForClauseCheck,
  hideMetaDataForContractReview,
} from "./constants";
import {
  ClauseCheckReviewType,
  ContractsReviewType,
  HeaderActionsType,
  ReviewSummaryType,
  SummaryMetricsType,
} from "./types";
import { getFileNameWithoutExtension } from "./utils";

export class MetaData {
  vertical: string;
  contractId: string;
  simbaId: string;
  documentId: string;
  vendor_name: string;
  service_type: string;
  contract_type: string;
  maximum_total_cost: string;
  start_date: any;
  end_date: any;
  maximum_billable_hours: any;
  constructor(obj: any) {
    this.vertical = obj?.vertical || "";
    this.contractId = obj?.contract_id || "";
    this.simbaId = obj?.simba_id || "";
    this.documentId = obj?.document_id || "";
    this.vendor_name = obj?.vendor_name || "";
    this.service_type = obj?.service_type || "";
    this.contract_type = obj?.contract_type || "";
    this.maximum_total_cost = `$${obj?.maximum_total_cost || 0}`;
    this.start_date = obj?.start_date || "";
    this.end_date = obj?.end_date || "";
    this.maximum_billable_hours = obj?.maximum_billable_hours || 0;
  }
}

export class ContractDocument {
  file_name: string;
  display_name!: string;
  created_at!: string;
  status!: string;
  metadata: MetaData;
  id: string;
  driveDetails: {};
  file_id?: string;
  loading?: boolean;
  error?: {};

  constructor(obj: any) {
    this.file_name = obj?.file_name || obj?.name;
    this.created_at = obj?.created_at;
    this.status = obj?.status;
    this.metadata = new MetaData(
      obj?.doc_meta?.metadata || obj?.doc_meta || obj?.clause_meta
    );
    this.id = obj?.id;
    this.display_name =
      obj?.display_name ||
      `${this.metadata?.vendor_name} ${this.metadata?.contract_type}`.trim() ||
      getFileNameWithoutExtension(obj?.name) ||
      this.file_name;
    this.driveDetails = obj?.drive_details;
    this.file_id = obj?.drive_details?.file_id || obj?.id;
  }
}

export class ContractReviewModel {
  headerText: string;
  headerActions: Array<HeaderActionsType>;
  user_docs: SummaryMetricsType[];
  pending_documents: ContractsReviewType;
  review_summary: Array<ReviewSummaryType>;
  recommendedPercentage: string;
  hideMetaData: string[];
  docId: string = "";
  constructor(obj: any) {
    this.headerText = DASHBOARD_FEATURES.CONTRACT_REDLINING;
    this.headerActions = headerActionsForContractReview;
    this.pending_documents = {
      list:
        obj?.pending_documents?.map((doc: any) => new ContractDocument(doc)) ||
        [],
      fileUpload: {
        isUploading: false,
        error: {},
        uploaded: false,
      },
    };
    this.docId = obj?.docId || "";
    this.review_summary =
      [{ category: "Recommendations" }].concat(obj?.review_summary || []) || [];
    this.recommendedPercentage = (
      (obj?.user_docs?.completed_docs / obj?.user_docs?.total_docs) *
      100
    ).toFixed(2);
    this.user_docs = [
      {
        count: obj?.user_docs?.pending_docs || 0,
        text: CONTRACTS_REVIEW_PENDING,
        descp: CONTRACT_REVIEW_PENDING_HEADER_DESCP,
      },
      {
        count: obj?.user_docs?.completed_docs || 0,
        text: CONTRACTS_COMPLETE_REVIEW,
        color: GREEN,
        descp: CONTRACTS_COMPLETE_REVIEW_HEADER_DESCP,
      },
    ];
    this.hideMetaData = hideMetaDataForContractReview;
  }
}

export class ClauseCheckModel {
  headerText: string;
  headerActions: Array<HeaderActionsType>;
  user_docs: SummaryMetricsType[];
  pending_documents: ClauseCheckReviewType;
  review_summary: Array<ReviewSummaryType>;
  recommendedPercentage: number;
  hideGraph: boolean;
  hideMetaData: string[];
  uploadProcessCompleted?: boolean;
  failed_documents: any;

  constructor(obj: any) {
    this.headerText = DASHBOARD_FEATURES.CLAUSE_CHECK;
    this.headerActions = headerActionsForClauseCheck;
    this.pending_documents = {
      list:
        obj?.pending_documents?.list?.map(
          (doc: any) => new ContractDocument(doc)
        ) || [],
    };
    this.review_summary =
      [{ category: "Standard Clauses" }].concat(
        obj?.review_summary || obj?.category_counts || []
      ) || [];

    this.recommendedPercentage =
      (obj?.user_docs?.completed_docs / obj?.user_docs?.total_docs) * 100;
    this.user_docs = [
      {
        count: obj?.pending_count || 0,
        text: CONTRACTS_PENDING_CLAUSE_CHECK,
        descp: CONTRACTS_PENDING_CLAUSE_CHECK_HEADER_DESCP,
      },
      {
        count: obj?.completed_count || 0,
        text: CONTRACT_COMPLIANCE,
        color: GREEN,
        descp: CONTRACT_COMPLIANCE_HEADER_DESCP,
      },
    ];
    this.hideGraph = true;
    this.hideMetaData = hideMetaDataForClauseCheck;
    this.uploadProcessCompleted = true;
  }
}

export class Suggestion {
  text: string;
  constructor(obj: any) {
    this.text = obj;
  }
}

export class ClauseCheckDocumentRequestModel {
  file_name: string;
  file_id: string;
  constructor(obj: any) {
    this.file_name = obj?.name;
    this.file_id = obj?.id;
  }
}

export class FileForRfxEvaluation {
  file_name: string;
  file_id_db: number;
  type_of_doc: string;
  constructor(obj: any) {
    this.file_name = obj?.file_name || obj?.name;
    this.file_id_db = obj?.file_id_db || obj?.id;
    this.type_of_doc = obj?.type_of_doc;
  }
}
